
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import {
  getBusinessData,
  getOrderData,
  getOverviewDishes,
  getSetMealStatistics,
} from '@/api/index'
import { getOrderListBy } from '@/api/order'
import Overview from './components/overview.vue'
import Orderview from './components/orderview.vue'
import CuisineStatistics from './components/cuisineStatistics.vue'
import SetMealStatistics from './components/setMealStatistics.vue'
import OrderList from './components/orderList.vue'

function aggregateOrderStatistics(records: any[]) {
  const init = { toBeConfirmed: 0, confirmed: 0, deliveryInProgress: 0 }
  if (!records || !records.length) return init
  return records.reduce((acc, vo) => {
    acc.toBeConfirmed += vo.toBeConfirmedCount || 0
    acc.confirmed += vo.confirmedCount || 0
    acc.deliveryInProgress += vo.deliveryInProgressCount || 0
    return acc
  }, { ...init })
}

@Component({
  name: 'Dashboard',
  components: {
    Overview,
    Orderview,
    CuisineStatistics,
    SetMealStatistics,
    OrderList,
  },
})
export default class extends Vue {
  private overviewData = {}
  private orderviewData = {} as any
  private dishesData = {} as any
  private setMealData = {}
  private page = 1
  private pageSize = 10
  private orderStatics = {} as any
  private fetchGeneration = 0
  private storeChangeTimer: ReturnType<typeof setTimeout> | null = null

  get currentStoreId(): string {
    return UserModule.storeId || ''
  }

  get dashboardScopeKey(): string {
    return this.currentStoreId || 'platform'
  }

  created() {
    this.init()
  }

  @Watch('currentStoreId')
  private onStoreIdChange(val: string, oldVal: string) {
    if (oldVal === undefined) return
    if (val === oldVal) return
    this.reloadDashboard()
  }

  private reportStoreId(): number | undefined {
    const id = this.currentStoreId
    if (!id) return undefined
    const n = Number(id)
    return Number.isNaN(n) ? undefined : n
  }

  private reloadDashboard() {
    if (this.storeChangeTimer) clearTimeout(this.storeChangeTimer)
    this.overviewData = {}
    this.orderviewData = {}
    this.dishesData = {}
    this.setMealData = {}
    this.orderStatics = {}
    this.storeChangeTimer = setTimeout(() => {
      this.storeChangeTimer = null
      this.init()
    }, 80)
  }

  beforeDestroy() {
    if (this.storeChangeTimer) clearTimeout(this.storeChangeTimer)
  }

  init() {
    const storeId = this.reportStoreId()
    const gen = ++this.fetchGeneration
    this.$nextTick(() => {
      this.loadBusinessData(gen, storeId)
      this.loadOrderOverview(gen, storeId)
      this.loadDishOverview(gen, storeId)
      // 商品套餐暂时隐藏
      // this.loadSetmealOverview(gen, storeId)
      this.getOrderListBy3Status(gen, storeId)
    })
  }

  private isStale(gen: number) {
    return gen !== this.fetchGeneration
  }

  async loadBusinessData(gen: number, storeId?: number) {
    try {
      const { data } = await getBusinessData(storeId)
      if (this.isStale(gen)) return
      this.overviewData = (data && data.data) || {}
    } catch (_) {
      if (this.isStale(gen)) return
      this.overviewData = {}
    }
  }

  private syncOrderStaticsFromOverview() {
    const o = this.orderviewData || {}
    this.orderStatics = {
      toBeConfirmed: o.waitingOrders || 0,
      confirmed: o.deliveredOrders || 0,
      deliveryInProgress: o.deliveringOrders || 0,
    }
  }

  async loadOrderOverview(gen: number, storeId?: number) {
    try {
      const { data } = await getOrderData(storeId)
      if (this.isStale(gen)) return
      this.orderviewData = (data && data.data) || {}
      if (storeId != null) {
        this.syncOrderStaticsFromOverview()
      }
    } catch (_) {
      if (this.isStale(gen)) return
      this.orderviewData = {}
      if (storeId != null) {
        this.orderStatics = {}
      }
    }
  }

  async loadDishOverview(gen: number, storeId?: number) {
    try {
      const { data } = await getOverviewDishes(storeId)
      if (this.isStale(gen)) return
      this.dishesData = (data && data.data) || {}
    } catch (_) {
      if (this.isStale(gen)) return
      this.dishesData = {}
    }
  }

  async loadSetmealOverview(gen: number, storeId?: number) {
    try {
      const { data } = await getSetMealStatistics(storeId)
      if (this.isStale(gen)) return
      this.setMealData = (data && data.data) || {}
    } catch (_) {
      if (this.isStale(gen)) return
      this.setMealData = {}
    }
  }

  getOrderListBy3Status(gen?: number, storeId?: number) {
    const sid = storeId != null ? storeId : this.reportStoreId()
    const currentGen = gen != null ? gen : this.fetchGeneration
    if (sid) {
      getOrderData(sid)
        .then((res) => {
          if (this.isStale(currentGen)) return
          const body = res.data || {}
          if (String(body.code) === '1' && body.data) {
            this.orderviewData = body.data
            this.syncOrderStaticsFromOverview()
          } else {
            this.orderStatics = {}
          }
        })
        .catch(() => {
          if (this.isStale(currentGen)) return
          this.orderStatics = {}
        })
      return
    }
    getOrderListBy({ page: this.page, pageSize: this.pageSize })
      .then((res) => {
        if (this.isStale(currentGen)) return
        const body = res.data || {}
        if (String(body.code) === '1' && body.data) {
          const records = body.data.records || []
          this.orderStatics = aggregateOrderStatistics(records)
        } else {
          this.orderStatics = {}
        }
      })
      .catch(() => {
        if (this.isStale(currentGen)) return
        this.orderStatics = {}
      })
  }
}
